module.exports = __webpack_public_path__ + "static/media/player-speed-comparison.4ae20f91.svg";